import * as signalR from "@microsoft/signalr";
import { getURL } from "../../constants";

const SignalR_URL = getURL() + "SignalR";

// ConnectionManager.js
class ConnectionManager {
    constructor() {
      this.connection = null;
      this.eventCallbacks = {};
      this.initPromise = null;
    }
  
    init(token, userProfile) {
      if (this.initPromise) 
        return this.initPromise;

      if (!userProfile.entid || !userProfile.siteid)
        return Promise.reject(new Error('No token (yet?)'));
  
      this.token = token;
      this.userProfile = userProfile;
      this.groupId =
        userProfile.entid.toString() + ":" + userProfile.siteid.toString();
      this.connection = getConnection(this.token);
  
      this.initPromise = this.connection.start().then(() => {
        this.initialized = true;
        this.joinGroup();
        this.registerInternalHandlers();
  
        // Register any callbacks that were added before initialization
        Object.keys(this.eventCallbacks).forEach((eventName) => {
          this.eventCallbacks[eventName].forEach((cb) => {
            this.connection.on(eventName, cb);
          });
        });
      });
  
      return this.initPromise;
    }
  
    disconnect() {
      if (this.connection) {
        // Stop the connection gracefully
        this.connection.stop();
        // Optionally, clear all event listeners if your connection object supports it
      }
      // Reset internal state to allow for a fresh initialization on next login
      this.connection = null;
      this.initialized = false;
      this.token = null;
      this.userProfile = null;
      this.groupId = null;
      this.eventCallbacks = {};
      this.initPromise = null;
    }
  
    joinGroup() {
      if (this.connection) {
        this.connection.invoke("JoinGroup", this.userProfile.email, this.groupId);
      }
    }
  
    registerInternalHandlers() {
      this.connection.onclose(() => {
        console.log("Connection closed");
      });
      this.connection.onreconnected(() => {
        this.joinGroup();
        // Reattach all event listeners on reconnect
        Object.keys(this.eventCallbacks).forEach((eventName) => {
          this.eventCallbacks[eventName].forEach((cb) => {
            this.connection.on(eventName, cb);
          });
        });
      });
    }
  
    on(eventName, callback) {
      if (!this.eventCallbacks[eventName]) {
        this.eventCallbacks[eventName] = [];
      }
      this.eventCallbacks[eventName].push(callback);
      
      if (this.connection) {
        this.connection.on(eventName, callback);
      }
    }
  
    off(eventName, callback) {
      if (this.eventCallbacks[eventName]) {
        this.eventCallbacks[eventName] = this.eventCallbacks[eventName]
        .filter((cb) => cb !== callback);
      }
  
      if (this.connection) {
        this.connection.off(eventName, callback);
      }
    }
  }
  
  
  function getConnection(token) {
    let connection = null;
    try {
      let conn = new signalR.HubConnectionBuilder()
        .withUrl(SignalR_URL, {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
          accessTokenFactory: () => {
            return token;
          },
        })
        .withAutomaticReconnect([10, 100, 1000, 10000, 30000])
        .build();
      conn.serverTimeoutInMilliseconds = 15 * 60e3;
      connection = conn;
    } catch (e) {
      console.log("getConnection error => " + JSON.stringify(e));
    }
    return connection;
  }
  
  // Export a single shared instance
  export const connectionManager = new ConnectionManager();
  